<template>
  <el-dialog :title="$t('productSeckill.addSeckill')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="addForm" :model="addProductSeckillInfo" label-width="120px" label-position="right">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$t('productSeckill.selectProduct')" prop="categoryId">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-select v-model="addProductSeckillInfo.categoryId" :placeholder="$t('productSeckill.selectGroup')"
                  style="width:100%" @change="_changeAddProductCatalorys">
                  <el-option v-for="item in addProductSeckillInfo.productCategorys" :key="item.categoryId"
                    :label="item.categoryName" :value="item.categoryId" />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select v-model="addProductSeckillInfo.productId" :placeholder="$t('productSeckill.selectProduct')"
                  style="width:100%" @change="_changeAddProduct">
                  <el-option v-for="item in addProductSeckillInfo.products" :key="item.productId" :label="item.prodName"
                    :value="item.productId" />
                </el-select>
              </el-col>
              <el-col :span="6">
                <el-select v-model="addProductSeckillInfo.valueId" :placeholder="$t('productSeckill.selectSpec')"
                  style="width:100%" @change="_changeAddProductSpec">
                  <el-option v-for="value in addProductSeckillInfo.values" :key="value.valueId"
                    :label="value.specName" :value="value.valueId" />
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="$t('productSeckill.seckillDesc')" prop="prodDesc">
            <el-input v-model="addProductSeckillInfo.prodDesc" type="textarea"
              :placeholder="$t('productSeckill.seckillDescPlaceholder')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.killStartTime')" prop="killStartTime">
            <el-time-picker v-model="addProductSeckillInfo.killStartTime" format="HH:mm" value-format="HH:mm"
              :placeholder="$t('productSeckill.killStartTimePlaceholder')" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.killEndTime')" prop="killEndTime">
            <el-time-picker v-model="addProductSeckillInfo.killEndTime" format="HH:mm" value-format="HH:mm"
              :placeholder="$t('productSeckill.killEndTimePlaceholder')" style="width:100%" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.validPurchase')" prop="totalCount">
            <el-input v-model="addProductSeckillInfo.totalCount" type="number"
              :placeholder="$t('productSeckill.validPurchasePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.onePurchaseCount')" prop="oneCount">
            <el-input v-model="addProductSeckillInfo.oneCount" type="number"
              :placeholder="$t('productSeckill.onePurchaseCountPlaceholder')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.killPrice')" prop="killPrice">
            <el-input v-model="addProductSeckillInfo.killPrice"
              :placeholder="$t('productSeckill.killPricePlaceholder')" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.limit')" prop="killStock">
            <el-input v-model="addProductSeckillInfo.killStock" :placeholder="$t('productSeckill.limitPlaceholder')" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.startTime')" prop="startTime">
            <el-date-picker v-model="addProductSeckillInfo.startTime" type="datetime"
              :placeholder="$t('productSeckill.startTimePlaceholder')" value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.endTime')" prop="endTime">
            <el-date-picker v-model="addProductSeckillInfo.endTime" type="datetime"
              :placeholder="$t('productSeckill.endTimePlaceholder')" value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="$t('productSeckill.status')" prop="state">
            <el-select v-model="addProductSeckillInfo.state" :placeholder="$t('productSeckill.statusPlaceholder')"
              style="width:100%">
              <el-option :label="$t('productSeckill.open')" value="1001" />
              <el-option :label="$t('productSeckill.close')" value="2002" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveProductSeckillInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveProductSeckill } from '@/api/group/productSeckillApi'
import { queryProductCategory, queryProduct } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddProductSeckill',
  data() {
    return {
      dialogVisible: false,
      addProductSeckillInfo: {
        categoryId: '',
        productId: '',
        valueId: '',
        killId: '',
        prodName: '',
        prodDesc: '',
        killStartTime: '',
        killEndTime: '',
        totalCount: '',
        oneCount: '',
        killPrice: '',
        killStock: '',
        state: '',
        startTime: '',
        endTime: '',
        productCategorys: [],
        products: [],
        values: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._listAddProductCategorys()
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addProductSeckillInfo = {
        categoryId: '',
        productId: '',
        valueId: '',
        killId: '',
        prodName: '',
        prodDesc: '',
        killStartTime: '',
        killEndTime: '',
        totalCount: '',
        oneCount: '',
        killPrice: '',
        killStock: '',
        state: '',
        startTime: '',
        endTime: '',
        productCategorys: this.addProductSeckillInfo.productCategorys,
        products: this.addProductSeckillInfo.products,
        values: []
      }
    },
    _normalizeKillTime(time) {
      if (!time) return ''
      const parts = time.split(':')
      const hour = String(parseInt(parts[0], 10)).padStart(2, '0')
      const minute = String(parseInt(parts[1] || '0', 10)).padStart(2, '0')
      return `${hour}:${minute}:00`
    },
    async saveProductSeckillInfo() {
      try {
        if (!this.addProductSeckillInfo.killStartTime) {
          this.$message.error(this.$t('productSeckill.killStartTimePlaceholder'))
          return
        }
        if (!this.addProductSeckillInfo.killEndTime) {
          this.$message.error(this.$t('productSeckill.killEndTimePlaceholder'))
          return
        }
        this.addProductSeckillInfo.killStartTime = this._normalizeKillTime(this.addProductSeckillInfo.killStartTime)
        this.addProductSeckillInfo.killEndTime = this._normalizeKillTime(this.addProductSeckillInfo.killEndTime)
        if (this.addProductSeckillInfo.killStartTime >= this.addProductSeckillInfo.killEndTime) {
          this.$message.error(this.$t('productSeckill.killTimeRangeInvalid'))
          return
        }

        this.addProductSeckillInfo.shopId = getShopId()
        await this.$refs.addForm.validate()
        await saveProductSeckill(this.addProductSeckillInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    },
    async _listAddProductCategorys() {
      try {
        const res = await queryProductCategory({
          page: 1,
          row: 100,
          shopId: getShopId()
        })
        this.addProductSeckillInfo.productCategorys = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _changeAddProductCatalorys() {
      try {
        const res = await queryProduct({
          page: 1,
          row: 100,
          shopId: getShopId(),
          categoryId: this.addProductSeckillInfo.categoryId
        })
        this.addProductSeckillInfo.products = res.data
      } catch (error) {
        console.error(error)
      }
    },
    async _changeAddProduct() {
      try {
        const res = await queryProduct({
          page: 1,
          row: 1,
          shopId: getShopId(),
          productId: this.addProductSeckillInfo.productId
        })
        this.addProductSeckillInfo.values = res.data[0].productSpecValues
        this.addProductSeckillInfo.prodDesc = res.data[0].prodDesc
      } catch (error) {
        console.error(error)
      }
    },
      async _changeAddProductSpec(){
        try{
            const valueId = this.addProductSeckillInfo.valueId;
            console.log(this.addProductSeckillInfo)
            for (let j=0;j<this.addProductSeckillInfo.values.length;j++) {
                let specValue = this.addProductSeckillInfo.values[j];
                if (specValue.valueId == valueId) {
                    this.addProductSeckillInfo.killPrice = specValue['ownerPrice']
                    this.addProductSeckillInfo.killStock = specValue['stock']
                    this.addProductSeckillInfo.totalCount = specValue['stock']
                    this.addProductSeckillInfo.oneCount = specValue['stock']
                    return;
                }
            }
        }catch (error) {
            console.log(error)
        }
      },
    _getValueSpecName(value) {
      let specName = ""
      value.productSpecDetails.forEach(item => {
        specName += (item.detailValue + ";")
      })
      return specName
    }
  }
}
</script>